import { render, staticRenderFns } from "./sectionSettingsCompenent.vue?vue&type=template&id=23890225"
import script from "./sectionSettingsCompenent.vue?vue&type=script&lang=js"
export * from "./sectionSettingsCompenent.vue?vue&type=script&lang=js"
import style0 from "./sectionSettingsCompenent.vue?vue&type=style&index=0&id=23890225&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports